const t = {
  name: "StarHalfFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 19.12V0.76001L8.33004 8.10001L1.04004 9.31001L6.41004 15.28L4.64004 22.87L12 19.12Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as StarHalfFilled
};
